import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {agreementConfirmination} from '../../../../actions/agreement.actions';
import {Button, ButtonGroup, PageContainer, PageDescription, PageTitle} from '../../../Common/PageComponents';

class DigitalKitDownloadAgreement extends Component {
  _cancel(e) {
    e.preventDefault();
    this.props.history.push('/news/tournament-kit');
  }

  _goToDownloadPage(e) {
    e.preventDefault();
    this.props.dispatch(agreementConfirmination('digitalKit'));
    this.props.history.push('/news/tournament-kit/digital-kit-download');
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="디지털 키트 다운로드" />
        <PageDescription>디지털 키트 다운로드를 위해 아래 약관에 동의하셔야 합니다.</PageDescription>
        <div className="join_kit_box">
          <strong>“리그 오브 레전드 디지털 키트” 운영 정책</strong>
          <br />
          <br />
          <dl>
            <dt>■</dt>{' '}
            <dd>
              리그 오브 레전드 디지털 키트 (이하 “디지털 키트”)는 리그 오브 레전드 가맹 PC방 (이하 “가맹 PC방”)에서
              자체적으로 진행하는 토너먼트(게임대회)를 지원할 목적으로 라이엇 게임즈에서 제작한 전용 홍보물입니다.
            </dd>
            <dt>■</dt>{' '}
            <dd>
              본 디지털 키트는 비상업적 용도의 가맹 PC방에서 자체적으로 진행되는 토너먼트를 위해서만 사용하실 수
              있습니다.
            </dd>
            <dt>■</dt>{' '}
            <dd>
              PC방 토너먼트에 대한 상세한 규정은 토너먼트 신청 페이지내 대회 규정 및 진행방법 안내를 참조하시기
              바랍니다.
              <br />
              <br />
            </dd>
            <b>
              <dt>1.</dt> <dd>디지털 키트 구성</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt> <dd>토너먼트용 대진표 이미지 – 3종 (8강 토너먼트식, 8강 패자부활전식, 4강 리그식)</dd>
              <dt>2)</dt>{' '}
              <dd>
                PC방 자체 토너먼트 홍보용 포스터 이미지 – 포스터 2종
                <br />
                <br />
              </dd>
            </span>
            <b>
              <dt>2.</dt> <dd>디지털 키트 다운로드</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt> <dd>사용 약관 동의 후 아래 다운로드 페이지를 통해 다운로드 받으실 수 있습니다.</dd>
              <dt>2)</dt> <dd>이미지 다운로드 후 직접 인쇄하여 사용이 가능합니다.</dd>
              <dt>3)</dt>{' '}
              <dd>
                디지털 키트는 PC방 자체 토너먼트의 홍보 목적으로만 사용이 가능합니다.
                <br />
                <br />
              </dd>
            </span>
            <b>
              <dt>3.</dt> <dd>디지털 키트 일반규정</dd>
            </b>
            <span className="indent_l">
              <dt>1)</dt>{' '}
              <dd>
                본 디지털 키트의 저작권은 Riot Games, Inc. 및 라이엇 게임즈 코리아의 소유로, 대한민국의 법률 및 관련
                국제법률과{' '}
                <a href="http://www.leagueoflegends.co.kr/?m=rules&cid=3" target="_blank" rel="noopener noreferrer">
                  리그 오브 레전드 최종 사용자 라이센스 계약
                </a>
                에 준하여 보호됩니다.
              </dd>
              <dt>2)</dt>{' '}
              <dd>
                본 디지털 키트는 어떠한 경우에도 판매, 복사, 교환, 전송, 양도 등을 하실 수 없으며, 단순한 PC방 자체
                토너먼트의 홍보 목적 외 수정, 배포, 2차 저작물 제작 등을 하실 수 없습니다.
              </dd>
              <dt>3)</dt> <dd>본 디지털 키트의 사용과 관련된 문의는 PC방 고객센터를 통해 전달해주시기 바랍니다.</dd>
            </span>
          </dl>
        </div>
        <ButtonGroup>
          <Button onClick={e => this._goToDownloadPage(e)}>동의</Button>
          <Button theme="gray" onClick={e => this._cancel(e)}>
            취소
          </Button>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect()(DigitalKitDownloadAgreement));
